/**
 * Products icon: pump dispenser bottle (lotion, shampoo, etc.).
 * Broad body, rounded corners, shoulders, neck, pump nozzle.
 */
export default function ProductsIcon({ size = 20, color = 'currentColor', style = {} }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ display: 'block', flexShrink: 0, ...style }}
    >
      {/* Bottle body - broad, short, rounded bottom corners */}
      <path d="M7 9 L7 20 Q7 22 12 22 Q17 22 17 20 L17 9 Q17 7 15 6 L9 6 Q7 7 7 9 Z" />
      {/* Shoulders and neck - curve inwards */}
      <path d="M9 6 L9 3 Q9 2 12 2 Q15 2 15 3 L15 6" />
      {/* Pump head - flat top, horizontal nozzle extending right, downward curve at tip */}
      <path d="M10.5 2 L13.5 2" />
      <path d="M12 2 L13 3 L14 4 Q14.5 5 13.5 5.5" />
      {/* Label - rounded rectangle on front */}
      <rect x="8.5" y="11" width="7" height="6" rx="0.8" fill="none" />
    </svg>
  );
}
